import { type FC } from 'react';
import { useTranslation } from 'react-i18next';

import { StringSmall } from '@/components/Typography/Typography';
import { useAppSelector } from '@/redux/store';

import { EarnRevenueItem } from './EarnRevenueItem';

interface EarnRevenueListProps {
  statusVIP: boolean | undefined;
  data: {
    percentage: { basePercent: number; vipPercent: number };
    volume: number;
    isActive?: boolean;
  }[];
}

const EarnRevenueList: FC<EarnRevenueListProps> = ({ statusVIP, data }) => {
  const { t } = useTranslation();
  const myCryptoPercent = useAppSelector(
    (state) => state.user.extendedInfo?.myCryptoPercent,
  );

  return (
    <div className="flex flex-col gap-1 w-full">
      <div className="flex h-8 items-center w-full px-4 rounded-lg bg-white/5 justify-between backdrop-blur-[32px]">
        <StringSmall className="!text-white/40">{t('Revenue')}</StringSmall>
        <StringSmall className="!text-white/40">{t('Volume')}</StringSmall>
      </div>
      {data.map((props, index) => (
        <EarnRevenueItem
          key={index}
          {...props}
          isVip={statusVIP}
          isActive={
            statusVIP
              ? myCryptoPercent === props.percentage.vipPercent
              : myCryptoPercent === props.percentage.basePercent
          }
        />
      ))}
    </div>
  );
};

export { EarnRevenueList };
